<template>
  <div>
    <top-bar voltar="admin"/>
    <menu-dash/>
    <div class="w3-main w3-small" style="margin-left:300px;margin-top:50px;">
      <header class="w3-container w3-cell-row" style="padding-top:22px">
        <button class="w3-button w3-round primary w3-right" @click="$router.push('produtos/cadastrar')"><i class="fa fa-plus"></i> <b>Cadastrar</b></button>
        <button class="w3-button w3-round primary w3-right" style="margin-right: 12px" @click="limparSearch()"><b>Limpar Filtros</b></button>
        <h6 class="w3-hide-small"><b>Produtos</b></h6>
      </header>
      <div class="w3-panel">
        <div class="w3-row-padding" style="margin:0 -16px">
          <div class="w3-card w3-white w3-padding-16">
            <div class="w3-row-padding w3-center">
              <div class="w3-col l3 w3-margin-top">
                <label for="referencia"><b>Referência</b></label>
                <input type="text" id="referencia" class="w3-input w3-border" placeholder="Ref Produto" v-model="referencia" @change="getProdutos(1)">
              </div>
              <div class="w3-col l3 w3-margin-top">
                <label for="nome"><b>Nome</b></label>
                <input type="text" id="nome" class="w3-input w3-border" placeholder="Nome do Produto" v-model="nomeProduto" @change="getProdutos(1)">
              </div>
              <div class="w3-col l3 w3-margin-top">
                <label for="tipo"><b>Categoria</b></label>
                <select id="tipo" class="w3-select w3-border w3-white" v-model="tipo" @change="getProdutos(1)">
                  <option value="0">Todas</option>
                  <option v-for="c in categorias" :value="c.id_categoria">{{c.nome_categoria}}</option>
                </select>
              </div>
              <div class="w3-col l3 w3-margin-top">
                <label for="status"><b>Status</b></label><br>
                <select id="status" class="w3-select w3-border w3-white" v-model="status" @change="getProdutos(1)">
                  <option value="">Todos</option>
                  <option value="1">Disponível</option>
                  <option value="2">Indisponível</option>
                </select>
              </div>
            </div>
          </div>
          <br>
          <div class="w3-card">
            <div class="w3-responsive w3-white table-produto">
              <table class="w3-table w3-hoverable w3-bordered w3-centered">
                <thead>
                  <tr class="primary">
                    <th style='width:5%'><i class="fa fa-tag"></i></th>
                    <th style='width:10%'>Referência</th>
                    <th style='width:35%'>Nome</th>
                    <th style='width:15%'>Ingrediente</th>
                    <th style='width:20%'>Categoria</th>
                    <th style='width:15%'>Status</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="p in produtos" @click="$router.push('produtos/editar/' + p.id_produto)">
                    <td><i class="fa fa-tag"></i></td>
                    <td>{{p.ref_produto}}</td>
                    <td>{{p.nome_produto}}</td>
                    <td>{{p.ingrediente === "1" ? "Sim" : "Não"}}</td>
                    <td>{{p.nome_categoria}}</td>
                    <td>{{p.fg_ativo === "1" ? "Disponível" : "Indisponível"}}</td>
                  </tr>
                </tbody>
              </table>
              <div class="w3-display-middle w3-center" v-show="naoEcontrado">
                <div>
                  <h2><i class="far fa-frown"></i></h2>
                  <span>Nenhum produto encotrado</span>
                </div>
              </div>
            </div>
            <div class="w3-bar w3-border">
              <button @click="getProdutos(--page)" class="w3-button" :disabled="!anterior">&#10094; Anterior</button>
              <button @click="getProdutos(++page)" class="w3-button w3-right" :disabled="!posterior">Próximo &#10095;</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import TopBar from "../../commons/TopBar.vue"
  import MenuDash from "../../commons/MenuDash.vue"

  export default {
    components: {TopBar, MenuDash},
    data() {
      return {
        token: localStorage.getItem('key'),
        page: 1,
        produtos: [],
        categorias: [],
        naoEcontrado: false,

        //pesquisa
        nomeProduto: '',
        tipo: 0,
        status: '',
        referencia: '',
        ingrediente: '',
        anterior: false,
        posterior: true,
      }
    },
    methods: {
      getProdutos(page) {
        openLoading("Buscando produtos!");
        this.page = page;
        let url = base_url + 'produtos/' + this.page + "/" + this.token;

        console.log(url + '?' +
          "nome=" + this.nomeProduto + '&' +
          "categoria=" + this.tipo + '&' +
          "referencia=" + this.referencia + '&' +
          "status=" + this.status + '&' +
          "ingrediente=" + this.ingrediente);

        this.$http.get(url + '?' +
          "nome=" + this.nomeProduto + '&' +
          "categoria=" + this.tipo + '&' +
          "referencia=" + this.referencia + '&' +
          "status=" + this.status + '&' +
          "ingrediente=" + this.ingrediente

        ).then(response => {
          if (response.data) {
            this.produtos = response.data.result;
            this.anterior = response.data.page > 1;
            this.posterior = response.data.page < response.data.pages;
            this.naoEcontrado = false;
          } else {
            this.produtos = [];
            this.naoEcontrado = true;
          }

          closeLoading();

        }, res => {
          closeLoading();
          openModalMsg(res.data.result, res.data.msg, true);
        });

      },

      buscarCategorias() {
        this.$http.get(base_url + 'categorias/' + localStorage.getItem('key'))
          .then(response => {
            this.categorias = response.data;

          }, res => {
            closeLoading();
            openModalMsg(res.data.result,res.data.msg);
          });
      },

      limparSearch() {
        this.nomeProduto = '';
        this.tipo = 0;
        this.referencia = '';
        this.status = '';
        this.ingrediente = 'false';

        this.getProdutos(1);
      }
    },

    mounted() {
      this.buscarCategorias();
      this.getProdutos(1);
    }
  }
</script>

<style scoped>
  .table-produto {
    min-height: 200px;
    position: relative;
  }

  .w3-centered tr td {
    cursor: pointer;
    padding: 13px
  }

  .w3-table td {
    vertical-align: middle;
  }
</style>



// WEBPACK FOOTER //
// src/components/admin/produto/Produtos.vue